import React from 'react';
import { getImageUrl, getResponsiveImageUrl } from '../../../utils/imageUrls';

/**
 * Renders a background image component.
 *
 * @param {Object} imgParams - The image parameters.
 * @param {string} imgParams.filename - The filename of the image.
 * @param {string} imgParams.alt - The alt text for the image.
 * @param {boolean} imgParams.inSlider - Indicates if the image is in a slider.
 * @param {string} zIndex - The z-index value for the component.
 * @returns {JSX.Element|null} The rendered background image component.
 */

const BgImage = ({ imgParams, zIndex }) => {
  if (!imgParams && !imgParams.filename && !imgParams.imageId) return null;

  const {
    id,
    alt,
    imagePosition,
    parentWidth,
    inSlider,
    forceAspect,
    imageId,
  } = imgParams;

  //console.log(imgParams);

  //fix for solving future issues with images being hosted on www2 instead of www.
  const filename = getImageUrl(imgParams.filename);

  const imagePositions = {
    topLeft: 'object-left-top',
    left: 'object-left',
    bottomLeft: 'object-left-bottom',
    centerLeftTop: 'object-[25%_0%]',
    centerLeft: 'object-[25%_50%]',
    centerLeftBottom: 'object-[25%_100%]',
    topCenter: 'object-top',
    center: 'object-center',
    bottomCenter: 'object-bottom',
    centerRightTop: 'object-[75%_0%]',
    centerRight: 'object-[75%_50%]',
    centerRightBottom: 'object-[75%_100%]',
    topRight: 'object-right-top',
    right: 'object-right',
    bottomRight: 'object-right-bottom',
  };

  const imageUrlParams = {
    filename: filename,
    imageId: imageId,
    parentWidth: parentWidth,
    inSlider: inSlider,
    forceAspect: forceAspect,
  };
  return (
    <picture
      key={id}
      className={`flex h-full w-full absolute ${zIndex} rounded`}
    >
      <source
        media="(max-width: 640px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '640px',
          ...imageUrlParams,
        })}
      />
      <source
        media="(max-width: 768px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '768px',
          ...imageUrlParams,
        })}
      />
      <source
        media="(max-width: 1024px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '1024px',
          ...imageUrlParams,
        })}
      />
      <source
        media="(min-width: 1024px)"
        srcSet={getResponsiveImageUrl({
          screenWidth: '1440px',
          ...imageUrlParams,
        })}
      />
      <img
        loading="lazy"
        src={getResponsiveImageUrl({ screenWidth: '640px', ...imageUrlParams })}
        alt={alt}
        className={`object-cover w-full rounded ${
          imagePositions[imagePosition] || imagePositions.center
        }`}
      />
    </picture>
  );
};

export default BgImage;
